//!#system	

<template>
	<v-app>
		<v-layout fill-height>
			<v-navigation-drawer permanent>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title class="title">
							Browser
						</v-list-item-title>
						<v-list-item-subtitle>
							Browse data in the app
						</v-list-item-subtitle>
						<v-text-field v-model="searchString" label="Find settings..." :clearable="true" />
					</v-list-item-content>
				</v-list-item>

				<div v-if="isLoading">
					<v-skeleton-loader
						v-for="itemGroup in itemGroups" :key="itemGroup.namespace"
						type="list-item-avatar, divider"
					></v-skeleton-loader>
				</div>

				<v-list class="pt-0" dense nav v-for="itemGroup in itemGroups" :key="itemGroup.namespace" v-if="!isLoading && itemGroup.items.length > 0">
					<v-divider v-if="itemGroup.items.length > 0"></v-divider>
					<v-list-item v-for="item in itemGroup.items" :key="item.friendly.pluralName" :disabled="!toLink(item)" :to="toLink(item)">
						<v-list-item-icon>
							<v-icon class="iconWidth">{{ item.icon }}</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{ item.friendly.pluralName }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				
			</v-navigation-drawer>
			
			<v-flex xs10>
				<keep-alive>
					<router-view></router-view>
				</keep-alive>
			</v-flex>

		</v-layout>
	</v-app>
</template>

<script>
import store from '@/store';
import apiService from '@/apiService';
import series from 'to-series';
export default {
	data() {
		return {
			drawer: true,
			searchString: '',
			items: [{"name":"automatedTaskGate","pluralName":"automatedTaskGates","namespace":"bpa","icon":"mdi-gate","colorVariant":"deep-purple accent-2","description":"These bucket items represent currently executing automated tasks.  They are automatically deleted after the task completes.","singleton":"","friendly":{"name":"Automated Task Gate","pluralName":"Automated Task Gates"},"path":"automated-task-gates","prefix":"AutomatedTaskGate","dashedNamespace":"bpa"},{"name":"leakyJug","pluralName":"leakyJugs","namespace":"bpa","icon":"mdi-format-color-fill","colorVariant":"light-blue","description":"Control mechanism to deal with external API rate limiting.","singleton":"","friendly":{"name":"Leaky Jug","pluralName":"Leaky Jugs"},"path":"leaky-jugs","prefix":"LeakyJug","dashedNamespace":"bpa"},{"name":"webhook","pluralName":"webhooks","namespace":"bpa","icon":"mdi-webhook","colorVariant":"blue-grey darken-3","description":"The results of webhooks.","singleton":"","friendly":{"name":"Webhook","pluralName":"Webhooks"},"path":"webhooks","prefix":"Webhook","dashedNamespace":"bpa"},{"name":"emailAttachment","pluralName":"emailAttachments","namespace":"comms","icon":"mdi-attachment","colorVariant":"blue-grey darken-3","description":"These are attachments that are linked to queued emails.","singleton":"","friendly":{"name":"Email Attachment","pluralName":"Email Attachments"},"path":"email-attachments","prefix":"EmailAttachment","dashedNamespace":"comms"},{"name":"emailStatus","pluralName":"emailStatuses","namespace":"comms","icon":"mdi-email-alert","colorVariant":"blue-grey darken-3","description":"The email-queue statuses that can be set on queued emails.","singleton":"","friendly":{"name":"Email Status","pluralName":"Email Statuses"},"path":"email-statuses","prefix":"EmailStatus","dashedNamespace":"comms"},{"name":"reportDefinition","pluralName":"reportDefinitions","namespace":"reporting","icon":"mdi-chart-tree","colorVariant":"blue-grey darken-3","description":"Reports for use in the reporting UIs.","singleton":"","friendly":{"name":"Report Definition","pluralName":"Report Definitions"},"path":"report-definitions","prefix":"ReportDefinition","dashedNamespace":"reporting"},{"name":"dashboardModuleType","pluralName":"dashboardModuleTypes","namespace":"system","icon":"mdi-view-dashboard-variant-outline","colorVariant":"blue-grey darken-3","description":"The types of dashboard modules that can be assigned in the app.","singleton":"","friendly":{"name":"Dashboard Module Type","pluralName":"Dashboard Module Types"},"path":"dashboard-module-types","prefix":"DashboardModuleType","dashedNamespace":"system"},{"name":"historyType","pluralName":"historyTypes","namespace":"system","icon":"mdi-history","colorVariant":"blue-grey darken-3","description":"The types of history events that are tracked on things in the app.","singleton":"","friendly":{"name":"History Type","pluralName":"History Types"},"path":"history-types","prefix":"HistoryType","dashedNamespace":"system"},{"name":"linker","pluralName":"linkers","namespace":"system","icon":"mdi-link","colorVariant":"blue-grey darken-3","description":"Linked objects across the app.","singleton":"","friendly":{"name":"Linker","pluralName":"Linkers"},"path":"linkers","prefix":"Linker","dashedNamespace":"system"},{"name":"recurrenceType","pluralName":"recurrenceTypes","namespace":"system","icon":"mdi-folder-clock-outline","colorVariant":"blue-grey darken-3","description":"The types of recurrence for tasks.","singleton":"","friendly":{"name":"Recurrence Type","pluralName":"Recurrence Types"},"path":"recurrence-types","prefix":"RecurrenceType","dashedNamespace":"system"},{"name":"startupController","pluralName":"startupControllers","namespace":"system","icon":"mdi-ray-start-arrow","colorVariant":"blue-grey darken-3","description":"List of startup actions that should be controlled.","singleton":"","friendly":{"name":"Startup Controller","pluralName":"Startup Controllers"},"path":"startup-controllers","prefix":"StartupController","dashedNamespace":"system"},{"name":"storageConnectionType","pluralName":"storageConnectionTypes","namespace":"system","icon":"mdi-file-cloud-outline","colorVariant":"blue-grey darken-3","description":"The types of storage services that are supported.","singleton":"","friendly":{"name":"Storage Connection Type","pluralName":"Storage Connection Types"},"path":"storage-connection-types","prefix":"StorageConnectionType","dashedNamespace":"system"},{"name":"stringTemplate","pluralName":"stringTemplates","namespace":"system","icon":"mdi-code-not-equal-variant","colorVariant":"blue-grey darken-3","description":"The string templates that turn data objects into nice looking text.","singleton":"","friendly":{"name":"String Template","pluralName":"String Templates"},"path":"string-templates","prefix":"StringTemplate","dashedNamespace":"system"},{"name":"subscription","pluralName":"subscriptions","namespace":"system","icon":"mdi-gauge","colorVariant":"blue-grey darken-3","description":"Subscription configuration.","singleton":"subscription","friendly":{"name":"Subscription","pluralName":"Subscriptions"},"path":"subscriptions","prefix":"Subscription","dashedNamespace":"system"},{"name":"userAvatar","pluralName":"userAvatars","namespace":"uac","icon":"mdi-face-man-profile","colorVariant":"light-blue darken-4","description":"The icon/avatar images that are used by users in the app.","singleton":"","friendly":{"name":"User Avatar","pluralName":"User Avatars"},"path":"user-avatars","prefix":"UserAvatar","dashedNamespace":"uac"},{"name":"userPref","pluralName":"userPrefs","namespace":"uac","icon":"mdi-file-account","colorVariant":"light-blue darken-4","description":"User preferences are stored here.","singleton":"","friendly":{"name":"User Pref","pluralName":"User Prefs"},"path":"user-prefs","prefix":"UserPref","dashedNamespace":"uac"},{"name":"userType","pluralName":"userTypes","namespace":"uac","icon":"mdi-account-settings","colorVariant":"light-blue darken-4","description":"The types of users in the app.","singleton":"","friendly":{"name":"User Type","pluralName":"User Types"},"path":"user-types","prefix":"UserType","dashedNamespace":"uac"}],
			mini: true,
			right: null,
			links: {},
			isLoading: false
		}
	},
	computed: {
		itemGroups: function() {
			let grouped = [], pos = ['uac'];
			grouped.push({ namespace: 'uac', items: [] }); // user browser first
			this.items.forEach(item => {
				let p = pos.indexOf(item.namespace);
				if (p === -1) {
					pos.push(item.namespace);
					p = pos.indexOf(item.namespace);
					grouped.push({ namespace: item.namespace, items: [] });
				}
			});

			grouped.forEach(group => {
				group.items = this.items.filter(item => item.namespace === group.namespace && (!this.searchString || (this.searchString && item.name.toLowerCase().includes(this.searchString.toLowerCase()))));
			});

			return grouped;
		}
	},
	methods: {
		toLink(item) {
			return this.links[item.dashedNamespace + '/' + item.path];
		},
		getInitialData() {
			this.isLoading = true;
			series()
				.each(this.items, (item, cb) => {
					if (!item.singleton) {
						this.links[item.dashedNamespace + '/' + item.path] = '/app/browser/' + item.dashedNamespace + '/' + item.path;
						return cb();
					}
					if (this.$store.state.app.contextLinks[item.dashedNamespace + '/' + item.path]) {
						this.links[item.dashedNamespace + '/' + item.path] = this.$store.state.app.contextLinks[item.dashedNamespace + '/' + item.path];
						return cb();
					}
					apiService.list({
						namespace: item.namespace,
						pluralName: item.pluralName
					}, (err, response, meta) => {
						if (err) {
							this.$store.dispatch('app/applyObjectError', {
								show: true,
								text: meta.validation ? meta.validation.messages.join('\n') : err
							});
						} else if (response.length <= 0) {
							this.$store.dispatch('app/applyObjectError', {
								show: true,
								text: 'Unable to locate this setting...'
							});
						} else {
							this.links[item.dashedNamespace + '/' + item.path] = '/app/browser/' + item.dashedNamespace + '/' + item.path + '/detail/' + encodeURIComponent(response[0].id);
							this.$store.dispatch('app/cacheContextLink', {
								key: item.dashedNamespace + '/' + item.path,
								link: this.links[item.dashedNamespace + '/' + item.path]
							});
						}
						return cb();
					});
				})
				.end(err => {
					this.isLoading = false;
				});
		}
	},
	beforeRouteLeave(to, from, next) {
		// called when the route that renders this component is about to
		// be navigated away from.
		// has access to `this` component instance.
		//console.log('Admins:beforeRouteLeave', to, from);
		if (store.state.app.mainDrawer===false) {
			//this.$store.dispatch('app/toggleDrawer');
		}
		return next();
	},
	created() {
		this.getInitialData();
	}
}
</script>

<style scoped>
.v-list-item__title {
  font-family: "Poppins"!important;
}
.iconWidth {
	width: 30px;
}
</style>